import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconDocSizeM from './FileIconDoc_size_m';
import FileIconDocSizeS from './FileIconDoc_size_s';

export const FileIconDoc = createFileIcon({
  m: FileIconDocSizeM,
  s: FileIconDocSizeS,
  name: 'FileIconDoc',
});
